export enum EBtnAttributeMatType {
    Base,
    Flat,
    Stroked,
}